export class GcpGrantedServices {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gceVm",
            "baseName": "gceVm",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "gceDisk",
            "baseName": "gceDisk",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "gcs",
            "baseName": "gcs",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "cloudsql",
            "baseName": "cloudsql",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "bigquery",
            "baseName": "bigquery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sapHana",
            "baseName": "sapHana",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpGrantedServices.attributeTypeMap;
    }
    constructor() {
    }
}
